import { useEffect } from "react";
import { Constants } from "../../Utils/Constants";

const RateTable = ({remmitanceData, leadInfo, params, showMessage, isQuotExp,handlePayOffline}) => {
    const paymentStatus = leadInfo.paymentstatus;
    const isQuotApproved = (leadInfo.quotationstatus === 'Approved') ? 'yes' : 'no';
    
    const quotDetailId = params.quotid;
    useEffect(() => {
      const makePayment = () => {
        const fieldsToEncode = ['api_key', 'amount', 'name', 'email', 'mobile', 'etm_estimate_no', 'callback_uri', 'env'];
        fieldsToEncode.forEach(field => {
          const inputField = document.getElementById(field);
          if (inputField) {
            inputField.value = window.btoa(inputField.value);
          }
        });
  
  
  
        document.getElementById('myForm').submit();
      };
      const submitButton = document.getElementById('submitButton');
      if (submitButton) {
        submitButton.addEventListener('click', makePayment);
      }
      return () => {
        // Cleanup the event listener when the component unmounts
        document.getElementById('submitButton')?.removeEventListener('click', makePayment);
      };
    }, [remmitanceData]);
    const callbackUri = Constants.COMMON_BACKEND_URL + `rapi/quotation/handle/${quotDetailId}/${params.status}/${params.bankid}`;
    console.log("Payment Link", Constants.PAYMENT_LINK);
    console.log("lead info", leadInfo);
    if (leadInfo?.name) {
      let nameArr = leadInfo?.name?.split(' ');
      let lNameArr = nameArr.length;
      leadInfo.first_name = nameArr[0];
      leadInfo.last_name = nameArr[lNameArr - 1];
      leadInfo.middle_name = nameArr.slice(0, nameArr-1).join(' ');
    }
  return (
    <>
      {!!Object?.keys(remmitanceData)?.length && (
        <div className="outerbox row justify-content-md-center">
          <div className="mainbx col-lg-5  col-md-6  col-sm-12">
            <div id="cartbreakup">
              <div className="table-responsive mrg-t20">
                <table className="table">
                  <tbody>
                    <tr>
                      <td className="black">Total Amount</td>
                      <td className="remitx-c">{(remmitanceData.fx_inr_total * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">GST on Total Amount</td>
                      <td className="remitx-c">{(remmitanceData.gst_fx_value * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">Bank Charges</td>
                      <td className="remitx-c">{(remmitanceData.correspondent_bank_fee * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">GST on Bank Charges</td>
                      <td className="remitx-c">{(remmitanceData.gst_correspondent_bank_fee * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">Bill Amount</td>
                      <td className="remitx-c">{(remmitanceData.total_bill_amount * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">TCS</td>
                      <td className="remitx-c">{(remmitanceData.tcs_value * 1).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td className="black">Grand Value</td>
                      <td className="remitx-c bold">{(remmitanceData.final_bill_amount * 1).toFixed()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col text-center">
                <form id="myForm" method="POST" action={Constants.PAYMENT_LINK} encType="application/x-www-form-urlencoded">
                  <input type="hidden" value={Constants.PAYMENT_API_KEY} name="api_key" id="api_key" />
                  <input type="hidden" value={leadInfo?.first_name + ' ' + leadInfo?.last_name} name="name" id="name" />
                  <input type="hidden" value={leadInfo?.email} name="email" id="email" />
                  <input type="hidden" value={leadInfo?.mobile} name="mobile" id="mobile" />
                  <input type="hidden" value={Constants.PAYMENT_ENV} name="env" id="env" />
                  <input
                    type="hidden"
                    value={
                      process.env.REACT_APP_PAYMENT_ENV === 'prod'
                        ? (remmitanceData.final_bill_amount * 1).toFixed()
                        : Constants.UAT_AMOUNT
                    }
                    name="amount"
                    id="amount"
                  />
                  <input type="hidden" value={quotDetailId} name="etm_estimate_no" id="etm_estimate_no" />
                  <input type="hidden" value={callbackUri} name="callback_uri" id="callback_uri" />

                  {paymentStatus === 'Failed' || !paymentStatus ? (
                    <>
                      {!isQuotExp && isQuotApproved && (
                        <input
                          type="button"
                          id="submitButton"
                          value={JSON.stringify(showMessage)?.includes('unsuccessful') ? 'Retry Payment' : 'Pay Now'}
                          className="btn btn-outline-primary paybtn mrg-r15"
                        />
                      )}
                      {!isQuotExp && isQuotApproved && (
                        <input onClick={handlePayOffline} type="button" value="Pay Offline" className="btn btn-outline-primary paybtn" />
                      )}
                    </>
                  ) : (
                    <p></p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default RateTable;
